// extracted by mini-css-extract-plugin
export default {"radio_group":"WidgetSwitchVariants_radio_group__0DID6","form_radio":"WidgetSwitchVariants_form_radio__z+yUT"};